var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckSquare = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5774 18.0254L11.6094 15.0574L9.72404 16.9427L14.756 21.9747L22.3587 12.8547L20.308 11.1454L14.5774 18.0254Z",
    fill: "#08C5A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4H6.66667C5.196 4 4 5.196 4 6.66667V25.3333C4 26.804 5.196 28 6.66667 28H25.3333C26.804 28 28 26.804 28 25.3333V6.66667C28 5.196 26.804 4 25.3333 4ZM6.66667 25.3333V6.66667H25.3333L25.336 25.3333H6.66667Z",
    fill: "#08C5A7"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-square.8f8d7546.svg";
export { ForwardRef as ReactComponent };